<template>
  <div class="card-input-response">
    <div class="title">{{ title }}</div>
    <div class="subtitle">{{ subtitle }}</div>
  </div>
</template>

<script>
export default {
  name: 'CardInputResponse',
  props: ['title', 'subtitle'],
};
</script>

<style lang="scss" scoped>
  @import '../../../node_modules/base-ui/src/scss/riseup-colors';

  .card-input-response {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    width: 100%;
    height: 135px;
    padding: 30px 36px;
    line-height: 1.2;
    color: white;
    background: $riseup_green;

    .title {
      font-family: SimplerProBold;
      font-size: 20px;
    }

    .subtitle {
      font-size: 16px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/base-components/card-parts/CardInputResponse.vue